<svg #svg class="stage-svg" [attr.viewBox]="'0 0 ' + VIEW_W + ' ' + VIEW_H"
     preserveAspectRatio="xMidYMid meet"
     (pointermove)="onMove($event)"
     (pointerup)="onUp($event)"
     (pointercancel)="onUp($event)"
     (pointerleave)="onUp($event)">

  <defs>
    <linearGradient id="zq-sky" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#201640" />
      <stop offset="34%" stop-color="#2f2258" />
      <stop offset="58%" stop-color="#4a3170" />
      <stop offset="74%" stop-color="#c9795c" />
      <stop offset="100%" stop-color="#e6a468" />
    </linearGradient>
    <linearGradient id="zq-ground" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="rgba(26,18,48,0.62)" />
      <stop offset="100%" stop-color="rgba(12,8,28,0.96)" />
    </linearGradient>
    <radialGradient id="zq-horizon" cx="50%" cy="100%" r="70%">
      <stop offset="0%" stop-color="rgba(255,206,140,0.55)" />
      <stop offset="100%" stop-color="rgba(255,206,140,0)" />
    </radialGradient>
    <radialGradient id="zq-lens" cx="38%" cy="32%" r="75%">
      <stop offset="0%" stop-color="#fff6dc" />
      <stop offset="45%" stop-color="#ffd98a" />
      <stop offset="100%" stop-color="#e0a13a" />
    </radialGradient>
    <radialGradient id="zq-lens-win" cx="38%" cy="32%" r="75%">
      <stop offset="0%" stop-color="#e9ffe6" />
      <stop offset="45%" stop-color="#9ee89a" />
      <stop offset="100%" stop-color="#2f9e50" />
    </radialGradient>
    <radialGradient id="zq-moon" cx="50%" cy="50%" r="50%">
      <stop offset="0%" stop-color="#fff7e6" />
      <stop offset="70%" stop-color="#ffe9c2" />
      <stop offset="100%" stop-color="rgba(255,233,194,0)" />
    </radialGradient>
    <filter id="zq-glow" x="-60%" y="-60%" width="220%" height="220%">
      <feGaussianBlur stdDeviation="5" result="b" />
      <feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
    </filter>
  </defs>

  <!-- Sky panel -->
  <rect x="0" y="0" [attr.width]="VIEW_W" [attr.height]="VIEW_H" fill="url(#zq-sky)" />

  <!-- Horizon glow behind the skyline -->
  <rect x="0" [attr.y]="LINE_Y - 150" [attr.width]="VIEW_W" height="180" fill="url(#zq-horizon)" />

  <!-- Moon + stars -->
  <circle cx="820" cy="118" r="70" fill="url(#zq-moon)" />
  <circle cx="820" cy="118" r="30" fill="#fff4dc" opacity="0.95" />
  <g fill="#ffffff">
    <circle cx="140" cy="70" r="2.2" class="star" /><circle cx="300" cy="52" r="1.5" class="star s2" />
    <circle cx="470" cy="84" r="2" class="star s3" /><circle cx="600" cy="60" r="1.6" class="star" />
    <circle cx="240" cy="120" r="1.5" class="star s2" /><circle cx="700" cy="150" r="1.8" class="star s3" />
    <circle cx="90" cy="150" r="1.6" class="star" /><circle cx="410" cy="140" r="1.4" class="star s2" />
  </g>

  <!-- Distant hills (all tiers) -->
  <g class="scenery">
    <path class="hills back" d="M0,380 Q180,306 380,344 T760,322 Q900,336 1000,352 L1000,380 Z" />
    <path class="hills front" d="M0,380 Q240,340 470,366 T940,344 L1000,352 L1000,380 Z" />

    <!-- Back skyline (from tier 1) -->
    <g class="skyline-back" *ngIf="sceneTier >= 1">
      <rect *ngFor="let b of SKYLINE" class="tower-back" rx="2"
            [attr.x]="b.x" [attr.y]="LINE_Y - b.h * 0.62"
            [attr.width]="b.w" [attr.height]="b.h * 0.62" />
    </g>

    <!-- Front skyline with lit windows (from tier 2) -->
    <g class="skyline-front" *ngIf="sceneTier >= 2">
      <g *ngFor="let b of SKYLINE; let i = index" [attr.transform]="'translate(' + b.x + ',' + (LINE_Y - b.h) + ')'">
        <rect class="tower" rx="3" x="0" y="0" [attr.width]="b.w" [attr.height]="b.h" />
        <ng-container *ngFor="let r of WINDOW_ROWS; let j = index">
          <circle class="win" [class.twinkle]="(i + j) % 4 === 0" [attr.cx]="b.w * 0.33" [attr.cy]="b.h * r" r="2.1" />
          <circle class="win" [class.twinkle]="(i + j) % 5 === 0" [attr.cx]="b.w * 0.67" [attr.cy]="b.h * r" r="2.1" />
        </ng-container>
      </g>
    </g>
  </g>

  <!-- Ground -->
  <rect x="0" [attr.y]="LINE_Y" [attr.width]="VIEW_W" [attr.height]="VIEW_H - LINE_Y" fill="url(#zq-ground)" />

  <!-- Number line -->
  <g filter="url(#zq-glow)">
    <line class="numline" [attr.x1]="X0 - 34" [attr.y1]="LINE_Y" [attr.x2]="X_END + 34" [attr.y2]="LINE_Y" />
  </g>

  <!-- Ticks + labels -->
  <g *ngFor="let t of ticks; let i = index">
    <line class="tick" [class.edge]="i === 0 || i === SEGMENTS"
          [attr.x1]="valToX(t)" [attr.y1]="LINE_Y - 14"
          [attr.x2]="valToX(t)" [attr.y2]="LINE_Y + 14" />
    <text class="tick-label" [attr.x]="valToX(t)" [attr.y]="LINE_Y + 48" text-anchor="middle">{{ fmt(t) }}</text>
  </g>

  <!-- Off-screen direction hints -->
  <g class="hint" *ngIf="hintDir === 'left'">
    <path [attr.d]="'M ' + (X0 - 12) + ' ' + (LINE_Y - 66) + ' l -30 20 l 30 20 Z'" />
    <text [attr.x]="X0 + 8" [attr.y]="LINE_Y - 40" class="hint-text">{{ currLang === 'ar' ? 'أصغر' : 'smaller' }}</text>
  </g>
  <g class="hint" *ngIf="hintDir === 'right'">
    <path [attr.d]="'M ' + (X_END + 12) + ' ' + (LINE_Y - 66) + ' l 30 20 l -30 20 Z'" />
    <text [attr.x]="X_END - 8" [attr.y]="LINE_Y - 40" class="hint-text" text-anchor="end">{{ currLang === 'ar' ? 'أكبر' : 'bigger' }}</text>
  </g>

  <!-- Sparkles on win -->
  <g *ngIf="solvedState">
    <circle *ngFor="let s of sparkles" class="sparkle" [attr.cx]="s.x" [attr.cy]="s.y" [attr.r]="s.r"
            [style.animation-delay.ms]="s.delay" />
  </g>

  <!-- Draggable magnifier marker -->
  <g class="marker" [class.win]="solvedState" [attr.transform]="'translate(' + markerX + ',0)'">
    <line class="marker-stem" x1="0" [attr.y1]="LINE_Y - 78" x2="0" [attr.y2]="LINE_Y - 14" />
    <g [attr.transform]="'translate(0,' + (LINE_Y - 106) + ')'">
      <rect class="marker-flag" x="-66" y="-30" width="132" height="60" rx="15" />
      <text class="marker-text" x="0" y="2" text-anchor="middle" dominant-baseline="central">{{ markerLabel }}</text>
    </g>
    <!-- lens -->
    <circle class="lens-halo" cx="0" [attr.cy]="LINE_Y" r="26" />
    <path class="lens-handle" [attr.d]="'M 12 ' + (LINE_Y + 12) + ' l 16 16'" />
    <circle class="lens" cx="0" [attr.cy]="LINE_Y" r="17" [attr.fill]="solvedState ? 'url(#zq-lens-win)' : 'url(#zq-lens)'" />
    <ellipse class="lens-shine" cx="-5" [attr.cy]="LINE_Y - 6" rx="6" ry="4" />
    <text *ngIf="solvedState" x="0" [attr.y]="LINE_Y + 7" text-anchor="middle" font-size="20">💎</text>
  </g>

  <!-- Drag band over the line -->
  <rect class="drag-band" [attr.x]="X0 - 30" [attr.y]="LINE_Y - 44"
        [attr.width]="(X_END - X0) + 60" height="88" fill="transparent" (pointerdown)="onDown($event)" />

  <!-- Wrong wash -->
  <rect *ngIf="wrongFlash" class="wrong-flash" x="0" y="0" [attr.width]="VIEW_W" [attr.height]="VIEW_H" />
</svg>
